module.exports = __webpack_public_path__ + "static/media/hagraphic.f00fdcfb.gif";